import {observer} from 'mobx-react';
import Celebration from './Celebration';
import {FormattedMessage} from 'react-intl';

const Birthday = observer(({birthday, emojiReady}) => {
  return (
    <Celebration
      employee={birthday.employee}
      date={birthday.publishedAt}
    >
      <FormattedMessage
        id='hr_dashboard.feed.celebrations.BIRTHDAY_MESSAGE'
        values={{
          link: <a href={`/employees/${birthday.employee.id}`}>
                  {birthday.employee.name}
                </a>
        }}
      />
      {emojiReady && <span className='ml1'>
        <em-emoji className='emoji-icon' id='cake' set='native' size='22px'></em-emoji>
      </span>}
    </Celebration>
  );
});

export default Birthday;
